import React from 'react';
import classNames from 'classnames';
import { SvgIcon, IconName } from '@adjust/dashboard-components';
import { UseConfirm } from '../../types';
import './Confirm.scss';

interface Props {
  confirm: UseConfirm;
}

export const Confirm: React.FC<Props> = ({ confirm }) => (
  <div
    className={classNames('confirm', {
      'confirm--visible': confirm.params,
      'confirm--success': confirm.isSuccess,
    })}
    data-testid="confirm"
  >
    <div className="confirm-content confirm-content--actions">
      <div className="confirm-title">Are you sure?</div>
      <div className="confirm-actions">
        <button className="btn btn--icon" onClick={confirm.close}>
          <SvgIcon name={IconName.Times} />
        </button>

        <button className="btn btn--icon" onClick={confirm.confirm} data-testid="confirm-checkmark-button">
          <SvgIcon name={IconName.Checkmark} />
        </button>
      </div>
    </div>

    <div className="confirm-content confirm-content--success">
      <div className="confirm-title">{confirm.params?.successMessage}</div>
    </div>
  </div>
);
